import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CrowdCellIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='22'
			viewBox='0 0 19 22'
			width='19'
			{...props?.innerSvgProps}
		>
			<path
				d='M9.7201 9.5L18 3M9.7201 9.5L1 7.42523M9.7201 9.5V21M18 3L8.94079 1L1 7.42523M18 3V14.3875L9.7201 21M1 7.42523V19L9.7201 21'
				stroke='#2E2E6B'
			/>
		</svg>
	);
};

export default CrowdCellIcon;

